import { render, staticRenderFns } from "./workbenchLayout.vue?vue&type=template&id=159e062e&scoped=true"
import script from "./workbenchLayout.vue?vue&type=script&lang=js"
export * from "./workbenchLayout.vue?vue&type=script&lang=js"
import style0 from "./workbenchLayout.vue?vue&type=style&index=0&id=159e062e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159e062e",
  null
  
)

export default component.exports